import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useNearContext } from '../contexts/NearContext';
import WalletButton from './WalletButton';

const Layout = ({ children }) => {
  const { isSignedIn, accountId, balance } = useNearContext();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-near-gradient rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">N</span>
              </div>
              <span className="text-xl font-bold text-gradient">NearBets</span>
            </Link>

            {/* Navigation */}
            <nav className="hidden md:flex space-x-8">
              <Link
                to="/"
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                  isActive('/') 
                    ? 'text-near-blue bg-blue-50' 
                    : 'text-gray-600 hover:text-near-blue hover:bg-gray-50'
                }`}
              >
                Browse Wagers
              </Link>
              <Link
                to="/create"
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                  isActive('/create') 
                    ? 'text-near-blue bg-blue-50' 
                    : 'text-gray-600 hover:text-near-blue hover:bg-gray-50'
                }`}
              >
                Create Wager
              </Link>
              {isSignedIn && (
                <Link
                  to="/my-wagers"
                  className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                    isActive('/my-wagers') 
                      ? 'text-near-blue bg-blue-50' 
                      : 'text-gray-600 hover:text-near-blue hover:bg-gray-50'
                  }`}
                >
                  My Wagers
                </Link>
              )}
            </nav>

            {/* Wallet Section */}
            <div className="flex items-center space-x-4">
              {isSignedIn && (
                <div className="hidden md:flex items-center space-x-2 text-sm text-gray-600">
                  <span>{balance} NEAR</span>
                  <span className="text-gray-400">|</span>
                  <span className="font-mono">{accountId}</span>
                </div>
              )}
              <WalletButton />
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden border-t border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex space-x-4 py-3">
              <Link
                to="/"
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                  isActive('/') 
                    ? 'text-near-blue bg-blue-50' 
                    : 'text-gray-600 hover:text-near-blue hover:bg-gray-50'
                }`}
              >
                Browse
              </Link>
              <Link
                to="/create"
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                  isActive('/create') 
                    ? 'text-near-blue bg-blue-50' 
                    : 'text-gray-600 hover:text-near-blue hover:bg-gray-50'
                }`}
              >
                Create
              </Link>
              {isSignedIn && (
                <Link
                  to="/my-wagers"
                  className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                    isActive('/my-wagers') 
                      ? 'text-near-blue bg-blue-50' 
                      : 'text-gray-600 hover:text-near-blue hover:bg-gray-50'
                  }`}
                >
                  My Wagers
                </Link>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center text-gray-600">
            <p className="text-sm">
              Built on NEAR Protocol  Decentralized P2P Betting Platform
            </p>
            <p className="text-xs mt-2">
               Disclaimer: Gambling may be regulated in your jurisdiction. Use responsibly.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
